import { Psychology } from "@mui/icons-material";
import {
  Box,
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
  Typography
} from "@mui/material";

import { getTimeRangeLabel } from "../../../utils/timerange";

interface CoachingConfirmDialogProps {
  open: boolean;
  onConfirm: () => void;
  onCancel: () => void;
  agentEmail: string;
  lensName: string;
  timeRange: string;
}

const CoachingConfirmDialog = ({
  open,
  onConfirm,
  onCancel,
  agentEmail,
  lensName,
  timeRange
}: CoachingConfirmDialogProps) => {
  return (
    <Dialog
      open={open}
      onClose={onCancel}
      maxWidth="sm"
      fullWidth
    >
      <DialogTitle sx={{ display: "flex", alignItems: "center", gap: 1 }}>
        <Psychology color="primary" />
        Generate Coaching Insights
      </DialogTitle>
      <DialogContent>
        <DialogContentText sx={{ mb: 2 }}>
          Generate coaching insights with the following configuration:
        </DialogContentText>
        <Box sx={{ p: 2, bgcolor: "grey.50", borderRadius: 1 }}>
          <Typography variant="body2" color="text.secondary" sx={{ mb: 1 }}>
            <strong>Agent:</strong> {agentEmail}
          </Typography>
          <Typography variant="body2" color="text.secondary" sx={{ mb: 1 }}>
            <strong>Lens:</strong> {lensName}
          </Typography>
          <Typography variant="body2" color="text.secondary">
            <strong>Time Range:</strong> {getTimeRangeLabel(timeRange)}
          </Typography>
        </Box>
        <DialogContentText sx={{ mt: 2 }}>
          This will automatically select all available attributes and generate training insights.
        </DialogContentText>
      </DialogContent>
      <DialogActions>
        <Button onClick={onCancel}>
          Cancel
        </Button>
        <Button
          onClick={onConfirm}
          variant="contained"
          color="primary"
          startIcon={<Psychology />}
        >
          Generate Insights
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default CoachingConfirmDialog;
